import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { SttTable, SttTopControls } from '../../../sporttia/all';
import FormQuestionDialog from '../../../components/dialogs/FormQuestionDialog';
import { PERMISSIONS } from '../../../lib/permissions';

type Props = {
    item: Activity;
    onChange: () => void;
};

type Activity = {
    id: number;
    form?: Question[];
};

type Question = {
    id: number;
    name: string;
    typeLang: string;
    mandatory: boolean;
};

type QuestionsData = {
    count: number;
    rows: Question[];
};

// Pestaña 'Formulario' para las actividades
export default function ActivityForm({
    item,
    onChange,
}: Props): React.ReactElement {
    const [questions, setQuestions] = useState<QuestionsData | null>(null);
    const [viewQuestion, setViewQuestion] = useState<
        Question | Record<string, never> | null
    >(null);

    const { t } = useTranslation();

    // Si cambia el item, recargamos el form (necesario al actualizar)
    useEffect(() => {
        if (item.form) {
            setQuestions({ count: item.form.length, rows: item.form });
        }
    }, [item]);

    function deleteForm(form: Question): void {
        setQuestions({
            count: questions ? questions.count - 1 : 0,
            rows:
                questions?.rows.filter(
                    (currentQuestion) => currentQuestion?.id !== form?.id,
                ) || [],
        });
    }

    return (
        <>
            <SttTopControls
                mb={6}
                mainAction={{
                    type: 'create',
                    permission: PERMISSIONS.ACTIVITY.MODIFY,
                    onClick: () => setViewQuestion({}),
                }}
            />
            <SttTable
                data={questions}
                hidePagination
                columns={[
                    {
                        title: t('Question'),
                        align: 'left',
                        type: 'link',
                        field: 'name',
                        onClick: (row: Question) => setViewQuestion(row),
                    },
                    {
                        title: t('Type'),
                        type: 'text',
                        field: 'typeLang',
                    },
                    {
                        title: t('Mandatory'),
                        type: 'active',
                        value: (row: Question) => !!row.mandatory,
                    },
                ]}
            />
            <FormQuestionDialog
                parentCategory="activities"
                idParent={item.id}
                item={viewQuestion as any}
                onSave={onChange}
                onDelete={deleteForm as any}
                onClose={() => setViewQuestion(null)}
                permission={PERMISSIONS.ACTIVITY.MODIFY}
            />
        </>
    );
}
